const graphQlPath = import.meta.env.VUE_APP_GRAPHQL_PATH
const invoicePreviewPath = import.meta.env.VUE_APP_INVOICE_PREVIEW_PATH
const baseUrl = import.meta.env.BASE_URL

export { baseUrl, graphQlPath, invoicePreviewPath }
